<template>
  <!--subPage 상단 Navi-->
  <div class="sub_Navi">
    <ul>
      <li><a @click="goBack" class="back">뒤로</a></li>
      <li>
        <h1>{{ $t("brief['notice']") }}</h1>
      </li>
      <li class="linkBox"></li>
    </ul>
  </div>
  <!--//subPage 상단 Navi :End-->
  <!--subPage -->
  <div class="subPage_container">
    <div class="bbs_info">
      <!-- <h5>
        {{ noticeDetail.title }}
      </h5> -->
      <p class="time">
        {{ noticeDetail.Date }}
        {{ noticeDetail.Time }}
      </p>
    </div>
    <div class="bbs_view_wrap">
      <div v-dompurify-html="noticeDetail.newContent"></div>
    </div>
  </div>
  <!--//subPage :End -->
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "NoticeDetail",
  computed: {
    ...mapState("board", ["noticeDetail"]),
  },
  methods: {
    goBack() {
      // console.log("Vue history state:", window.history.state);
      // console.log("history length:", window.history.length);

      this.$router.back();
    }
  }
};
</script>

<style scoped>
.bbs_view_wrap {
  width: 100%;
  padding: 30px 16px 0;
  color: var(--Secondary, #7E8088);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  line-height: 2;
  letter-spacing: 0.7px;
  overflow: hidden;
  border-top: none;
}

.bbs_view_wrap p {
  letter-spacing: 0.8px;
}

/* 이미지 컨테이너 클래스 */
.image-container {
  width: 100%;
  height: auto;
  overflow: hidden;
}

/* 이미지 클래스 */
.image-container img {
  width: 100% !important;
  height: auto;
  object-fit: cover;
  margin: 15px 0;
}
</style>
